'use client';

import { MetaCreateView } from '@/components/MetaCreateView';
import { AppHeaderConfig } from '@/contexts/AppHeaderContext';

export default function NewMetaPage() {
  return (
    <>
      <AppHeaderConfig hidePeriodPicker />
      <MetaCreateView />
    </>
  );
}
